import React, { useState, useEffect } from 'react';
import { Package, Grid3x3, TrendingUp, AlertCircle } from 'lucide-react';
import adminApi from '../../lib/adminApi';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalCollections: 0,
    lowStockProducts: 0,
    totalValue: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const [productsRes, collectionsRes] = await Promise.all([
          adminApi.get('/api/admin/products'),
          adminApi.get('/api/admin/collections')
        ]);

        const products = productsRes.data;
        const collections = collectionsRes.data;
        const lowStock = products.filter(p => p.stock < 20).length;
        const totalValue = products.reduce((sum, p) => sum + (p.price * p.stock), 0);

        setStats({
          totalProducts: products.length,
          totalCollections: collections.length,
          lowStockProducts: lowStock,
          totalValue: totalValue.toLocaleString('fr-FR')
        });
      } catch (error) {
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
    loadStats();
  }, []);

  const statCards = [
    {
      icon: Package,
      label: 'Total Produits',
      value: stats.totalProducts,
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: Grid3x3,
      label: 'Collections',
      value: stats.totalCollections,
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: AlertCircle,
      label: 'Stock Faible',
      value: stats.lowStockProducts,
      color: 'from-orange-500 to-red-600'
    },
    {
      icon: TrendingUp,
      label: 'Valeur Totale',
      value: `${stats.totalValue} €`,
      color: 'from-green-500 to-green-600'
    }
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-400">Chargement...</div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-3xl font-bold text-white mb-8">Tableau de bord</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.label}
              className="bg-gray-900 rounded-lg p-6 border border-gray-800"
            >
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${stat.color} flex items-center justify-center`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
              <p className="text-gray-400 text-sm mb-1">{stat.label}</p>
              <p className="text-2xl font-bold text-white">{stat.value}</p>
            </div>
          );
        })}
      </div>

      <div className="bg-gray-900 rounded-lg p-6 border border-gray-800">
        <h2 className="text-xl font-bold text-white mb-4">Bienvenue dans l'administration</h2>
        <p className="text-gray-400 mb-4">
          Utilisez le menu de gauche pour gérer vos produits et collections.
        </p>
        <ul className="text-gray-400 space-y-2">
          <li>• Gérez vos produits LED</li>
          <li>• Modifiez les prix et les stocks</li>
          <li>• Organisez vos collections</li>
          <li>• Ajoutez de nouvelles images</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminDashboard;